import { apiUrl } from '../config';

const LITE_AVATAR_BASE_URL = 'https://s3.eu-west-1.amazonaws.com/uploads.globalandxl.nl/glxl-lite-avatars';

/**
 * Get group icon urls
 * @param {array<string>} themes
 * @param {array<{}>} groups 
 * @return {array<string>}
 */
const getGroupIcons = (themes = [], groups = []) => {
  return themes.map((theme, i) => {
    const g = groups.find(g => g.GroupTheme.color === theme);
    if (g) return apiUrl + g.GroupTheme.badge;
    return null;
  });
};

/**
 * Returns the avatar url to display for a group.
 * Falls back to a color-specific placeholder for LITE projects, or the
 * provided fallback otherwise.
 * @param {{ Avatar?: { url: string }, GroupTheme?: { color: string } }} group
 * @param {{ lite?: boolean }} [project]
 * @param {string} [fallback]
 * @returns {string}
 */
const getGroupAvatarUrl = (group, project, fallback = '') => {
  if (group && group.Avatar && group.Avatar.url) {
    return group.Avatar.url;
  }
  if (project && project.lite && group && group.GroupTheme && group.GroupTheme.color) {
    return `${LITE_AVATAR_BASE_URL}/${group.GroupTheme.color}.png`;
  }
  return fallback;
};

export {
  getGroupIcons,
  getGroupAvatarUrl,
};



// WEBPACK FOOTER //
// ./src/helpers/groupHelper.js